import { render, staticRenderFns } from "./modal-create-label.vue?vue&type=template&id=38fb8e0c&"
import script from "./modal-create-label.vue?vue&type=script&lang=js&"
export * from "./modal-create-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports